export default function TextArea({
  value,
  name,
  onChange,
  onBlur,
  className,
  placeholder,
  validated,
  error,
  disabled,
  height,
}) {
  const defaultClasses = `py-8 px-8 w-full rounded-half border-2 border-gray-300 focus:ring-0 focus-visible:ring-0 placeholder-gray-300 text-gray-800 ${
    validated || error || disabled
      ? ''
      : 'focus:border-gray-400 focus-visible:border-gray-400'
  } ${height ? `h-${height}` : 'h-36'}`;
  let stateClasses = '';

  if (validated) {
    stateClasses = 'border-primary focus:border-primary';
  }

  if (error) {
    stateClasses = 'border-secondary focus:border-secondary';
  }

  if (disabled) {
    stateClasses = 'bg-gray-100';
  }

  return (
    <div className="relative">
      <textarea
        className={`form-input ${defaultClasses} ${stateClasses} ${
          className ? className : ''
        }`}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        disabled={Boolean(disabled)}
      />
    </div>
  );
}
